export default {
    EXTENSION_ID: 188,
    AUTO_COMPLETE_TYPE_KEY: 6
}
